import { useEffect } from 'react';

const REVEAL_SELECTOR = '[data-reveal]';
const READY_CLASS = 'reveal-ready';

/**
 * Subtle entrance reveals. The stylesheet only hides elements once
 * READY_CLASS is set here, so content stays visible if this never runs.
 */
export function useReveal(): void {
  useEffect(() => {
    const targets = document.querySelectorAll(REVEAL_SELECTOR);
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!targets.length || reduced || !('IntersectionObserver' in window)) return;

    const root = document.documentElement;
    root.classList.add(READY_CLASS);

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.06 },
    );

    targets.forEach((el) => observer.observe(el));

    return () => {
      observer.disconnect();
      root.classList.remove(READY_CLASS);
    };
  }, []);
}
